import { useTranslation } from 'react-i18next'

import {
  Card,
  Background,
  Hero,
  Logo,
  Fade,
  TipWrapper
} from './styles'

import Tip from '../Tip'

import valorantBackground from './assets/background/valorant.svg'
import valorantLogo from './assets/logo/valorant.svg'
import valorantHero from './assets/hero/valorant.png'

import csgoBackground from './assets/background/csgo.svg'
import csgoLogo from './assets/logo/csgo.svg'
import csgoHero from './assets/hero/csgo.png'

import dota2Background from './assets/background/dota2.svg'
import dota2Logo from './assets/logo/dota2.svg'
import dota2Hero from './assets/hero/dota2.png'

import apexBackground from './assets/background/apex.svg'
import apexLogo from './assets/logo/apex.svg'
import apexHero from './assets/hero/apex.png'

import warzoneBackground from './assets/background/warzone.svg'
import warzoneLogo from './assets/logo/warzone.svg'
import warzoneHero from './assets/hero/warzone.png'

import fortniteBackground from './assets/background/fortnite.svg'
import fortniteLogo from './assets/logo/fortnite.svg'
import fortniteHero from './assets/hero/fortnite.png'

import lolBackground from './assets/background/lol.svg'
import lolLogo from './assets/logo/lol.svg'
import lolHero from './assets/hero/lol.png'


import { IGamesName } from 'interfaces/IGames'

const assets = {
  valorant: {
    bg: valorantBackground,
    logo: valorantLogo,
    hero: valorantHero
  },
  csgo: {
    bg: csgoBackground,
    logo: csgoLogo,
    hero: csgoHero
  },
  dota2: {
    bg: dota2Background,
    logo: dota2Logo,
    hero: dota2Hero
  },
  apex: {
    bg: apexBackground,
    logo: apexLogo,
    hero: apexHero
  },
  warzone: {
    bg: warzoneBackground,
    logo: warzoneLogo,
    hero: warzoneHero
  },
  fortnite: {
    bg: fortniteBackground,
    logo: fortniteLogo,
    hero: fortniteHero
  },
  lol: {
    bg: lolBackground,
    logo: lolLogo,
    hero: lolHero
  }
}

interface Props {
  game: 'valorant' | 'csgo' | 'dota2' | 'apex' | 'warzone' | 'fortnite' | 'lol',
  soon?: boolean
}

export default function GameCard({ game, soon }: Props) {

  const { t, i18n } = useTranslation()

  return (
    <a href={window.location.href.replace("app", game)}>
      <Card>
        {soon && <TipWrapper><Tip>{t('btns.soon')}</Tip></TipWrapper>}
        <Background src={assets[game]?.bg} loading='lazy' alt={game} />
        <Hero src={assets[game]?.hero} loading='lazy' alt={game} />
        <Logo src={assets[game]?.logo} loading='lazy' alt={game} />
        <Fade />
      </Card>
    </a>
  );
}